import axios from 'axios'

export function getFileEndpoint(filename: string): string {
    const baseURL =
        process.env.REACT_APP_MODE === 'cloud'
            ? process.env.REACT_APP_API_ENDPOINT
            : `http://${window.location.hostname}:4000/api`

    return `${baseURL}/media/file?filename=${filename.replaceAll(
        '&',
        '%26'
    )}&authorization=${localStorage.getItem('token')}`
}

export function downloadFile(filename: string) {
  const url = getFileEndpoint(filename)
  window.open(url, '_blank')
}

export async function getFileInBase64(filename: string): Promise<string> {
    return new Promise<string>((resolve, reject) => {
        axios
            .get(getFileEndpoint(filename), {
                responseType: 'blob',
            })
            .then((response) => {
                const reader = new FileReader()
                reader.readAsDataURL(response.data)
                reader.onloadend = function () {
                    resolve(reader.result as string)
                }
            })
            .catch((err) => reject(err))
    })
}
